<template>
	<div class="home">
		<h2>Top Rated Movies</h2>
		
		<Carousel v-if="moviesListTop.length > 0" :arraydata="moviesListTop" type="movie" :link='true' />
		
		
		<h2>Popular Movies</h2>
		<Carousel v-if="moviesListPopular.length > 0" :arraydata="moviesListPopular" type="movie" :link='true' />
		
		
		<h2>Up Comming Movies</h2>
		
		<Carousel v-if="moviesListUpComing.length > 0" :arraydata="moviesListUpComing" type="movie" :link='true' />

		<h2>Top Rated Tv Show</h2>

		<Carousel v-if="tvListTop.length > 0" :arraydata="tvListTop" type="tv" :link='true' />


		<h2>Popular Tv Show</h2>
		<Carousel v-if="tvListPopular.length > 0" :arraydata="tvListPopular" type="tv" :link='true' />


	
	
	
	</div>
</template>

<script>
	import ApiProducts from "@/mixins/ApiProducts";
	import Carousel from "@/components/Carousel";
	import {Carousel3d, Slide} from 'vue-carousel-3d';
	
	import axios from 'axios'
	
	export default {
		name: 'Home',
		components: {
			Carousel3d,
			Slide,
            Carousel
		},
		data: function () {
			return {
				moviesList: [],
				moviesListTop: [],
				moviesListPopular: [],
				moviesListUpComing: [],
				tvListTop: [],
				tvListPopular: [],
				isVisible: true,
				
			}
		},
		mounted() {
			this.getMoviesLatest()
				.then(data => {
					if (data) {
						this.moviesList = data
					} else {
						this.moviesList.push(data)
					}
				})
				.catch(err => console.log(err));
			
			this.getMoviesTopRated()
				.then(data => {
					if (data) {
						this.moviesListTop = data
					} else {
						this.moviesListTop.push(data)
					}
				})
				.catch(err => console.log(err));
			
			this.getMoviesPopular()
				.then(data => {
					if (data) {
						this.moviesListPopular = data
					} else {
						this.moviesListPopular.push(data)
					}
				})
				.catch(err => console.log(err));
			
			this.getMoviesUpComing()
				.then(data => {
					if (data) {
						this.moviesListUpComing = data
					} else {
						this.moviesListUpComing.push(data)
					}
				})
				.catch(err => console.log(err));

			this.getTvTopRated()
				.then(data => {
					if (data) {
						this.tvListTop = data
					} else {
						this.tvListTop.push(data)
					}
				})
				.catch(err => console.log(err));

			this.getTvPopular()
				.then(data => {
					if (data) {
						this.tvListPopular = data
					} else {
						this.tvListPopular.push(data)
					}
				})
				.catch(err => console.log(err));
		},
		methods: {

			
		},
		
		mixins: [ApiProducts]
		
	}
</script>

<style lang="scss" scoped>
	.product__item {
		img {
			width: 100px;
		}
	}
	
	.home {
		
		padding:0 3%;
		height: 90vh;
		overflow-x: auto;
		
	h2{
		color: #fff;
	}
	}
	
	.home::-webkit-scrollbar {
	margin:20px;
		width: 5px;
		background: #888;
		border-radius:10px;
	}
	.home::-webkit-scrollbar-thumb {
		background: #000000;
		border-radius:10px;
		
	}
	
	
	
	

</style>